import i18n from "@/i18n";

export type FeedFormatOption = {
  label: string;
  value: string;
};

export const getFeedFormatOptions = (): FeedFormatOption[] => [
  { label: i18n.t("feedFormats.defaultRecruitNow"), value: "DefaultRecruitNow" },
  { label: i18n.t("feedFormats.recruitNowApply"), value: "RecruitNowApply" },
  { label: i18n.t("feedFormats.vaproRecruitment"), value: "VaproRecruitment" },
  { label: i18n.t("feedFormats.undutchables"), value: "Undutchables" },
  { label: i18n.t("feedFormats.bmc"), value: "BMC" },
  { label: i18n.t("feedFormats.tempoTeamRandstad"), value: "TempoTeamRandstad" },
  { label: i18n.t("feedFormats.synergie"), value: "Synergie" },
  { label: i18n.t("feedFormats.zorgwerk"), value: "Zorgwerk" },
  { label: i18n.t("feedFormats.abvakwerk"), value: "Abvakwerk" },
  { label: i18n.t("feedFormats.timing"), value: "Timing" },
];
